import React, { useState, useEffect } from 'react'
import IconBalon from '../Logo/IconBalon'
import styled from 'styled-components'
import { format, parse } from 'date-fns'
import esLocale from 'date-fns/locale/es'
import differenceInYears from 'date-fns/differenceInYears'
import isWithinInterval from 'date-fns/isWithinInterval'
import PostImage from '@/components/Featured/Mundial62/Posts/PostImage'

const Wrap = styled.div`
  border: 2px solid #2a0b0e;
  padding: 1rem;
  background-color: rgba(255, 255, 255, 0.8);
  h2 {
    font-family: 'Futura', sans-serif;
    letter-spacing: 0.01em;
    text-align: center;
    text-transform: uppercase;
    font-size: 1.2rem;
    line-height: 1.1;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    small {
      display: block;
      margin-top: 0.5rem;
    }
  }
  figure {
    background-color: #fff;
    border: 1px solid black;
    .default {
      display: block;
      width: 100%;
      height: 0;
      padding-bottom: 125%;
      position: relative;
      .wrap {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        svg {
          max-width: 50%;
          width: 200px;
        }
        .number {
          font-family: 'Futura', sans-serif;
          font-size: 1.5rem;
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: 3px;
          transform: translate(-50%, -50%);
          color: white;
        }
      }
    }
  }
  dl {
    font-family: 'Futura', sans-serif;
    dt {
      font-size: 0.7rem;
      letter-spacing: 0.01em;
      text-transform: uppercase;
    }
  }
`

const Lamina = styled.div`
  border: 8px solid #fef3df;
  margin: 4px 2px;
  position: absolute;
  z-index: 19;
  box-shadow: 2px 3px 6px 3px rgba(0, 0, 0, 0.2);
  /* transform: rotate(-1deg); */
`

const PlayerLoop = ({ player }) => {
  const [club, setClub] = useState()
  const {
    title,
    featuredImage,
    playerFields: { number, born, died, clubs, position },
  } = player

  const strToDate = str => {
    const date = parse(str, 'yyyyMMdd', new Date())
    return format(date, "dd 'de' MMMM 'de' yyyy", { locale: esLocale })
  }

  const age = (firstDate, secondDate) => {
    const firstDateParsed = parse(firstDate, 'yyyyMMdd', new Date())
    const secondDateOrToday = secondDate
      ? parse(secondDate, 'yyyyMMdd', new Date())
      : new Date()
    return differenceInYears(secondDateOrToday, firstDateParsed)
  }

  const clubIn1962 = clubs => {
    const mundialDate = parse('19620530', 'yyyyMMdd', new Date())
    return clubs.find(club => {
      const between = club.periodo.split('-')
      const start = parse(`${between[0]}0101`, 'yyyyMMdd', new Date())
      const end = between[1]
        ? parse(`${between[1]}1231`, 'yyyyMMdd', new Date())
        : parse(`${between[0]}1231`, 'yyyyMMdd', new Date())
      const isInThisClub = isWithinInterval(mundialDate, { start, end })
      if (isInThisClub) {
        return club
      }
    })
  }

  useEffect(() => {
    const period = clubIn1962(clubs)
    setClub(period.club)
  }, [])

  // create random number between -1.5 and 1.5 with 0.1 precision
  const random = () => {
    return Math.random() * (1.5 - -1.5) + -1.5
  }

  return (
    <Wrap>
      <figure>
        <span className="default">
          <Lamina style={{ transform: `rotate(${random()}deg)` }}>
            <PostImage
              image={featuredImage}
              alt={`${title}-${position.name}`}
            />
          </Lamina>
          <span className="wrap">
            <span className="number">{number}</span>
            <IconBalon fill="#2a0b0e" />
          </span>
        </span>
      </figure>
      <h2>
        {title}
        <small>{position.name}</small>
      </h2>

      <dl>
        <dt>Edad al jugar:</dt>
        <dd>{age(born, '19620530')} años</dd>
        <dt>Club:</dt>
        <dd>{club && club.name}</dd>
        <dt>Nacimiento:</dt>
        <dd>
          {strToDate(born)} {!died && <>({age(born)} años)</>}
        </dd>
        {died && (
          <>
            <dt>Defunción:</dt>
            <dd>
              {strToDate(died)} ({age(born, died)} años)
            </dd>
          </>
        )}
      </dl>
    </Wrap>
  )
}

export default PlayerLoop
